import { Container, ContainerGutter, ContainerPadding, List, ListGutter, ListItem, Richtext, styled, Text, TokenTextAppearance, TokenTextColor } from "@volkswagen-onehub/components-core";
import React from "react";
import { LayerCloseHandle } from "../../types/layers";
import ModalFrameCloseCta from "../ModalFrameCloseCta";

const RichTextContainer = styled(Text)``;

interface Props {
  close: LayerCloseHandle;
  header: string;
  category: string;
  highlights: string[];
  desc: string | null;
};

export const FullDescription = ({close, header, category, highlights, desc}: Props) => {

  return (
    <Container wrap="always" gutter={ContainerGutter.dynamic0100} stretchContent>
    <Container horizontalAlign="space-between">
        <Container padding={{top: ContainerPadding.dynamic0050, left: ContainerPadding.grid001}}>
            <Text appearance={TokenTextAppearance.headline100} bold color={TokenTextColor.inherit}>{ header }</Text>
        </Container>
        <ModalFrameCloseCta aria='Hide more vehicles specs and overview' onClickHandler={close} />
    </Container>


    <Container
        wrap="always" padding={
            {
                bottom: ContainerPadding.dynamic0040,
                right: ContainerPadding.grid001,
                left: ContainerPadding.grid001
            }
        }>

        {category === "new" &&
            <Container padding={{left: ContainerPadding.static350}}>
                {highlights?.length && <List
                        appearance={TokenTextAppearance.copy200}
                        gutter={ListGutter.static100}>
                        { highlights && highlights.length && highlights.map((highlight, i) => {
                          const key = `highlight-${i}`;
                                return (
                                    <ListItem markerSize={0} key={key}>
                                      <Text>
                                        <Richtext markdown={highlight} dangerouslyParseRawHTML />
                                      </Text>
                                    </ListItem>
                                );
                            })
                        }
                    </List>
                }
            </Container>
        }

        {category !== "new" && desc &&
            <RichTextContainer>
                <Richtext markdown={desc} dangerouslyParseRawHTML />
            </RichTextContainer>
        }
    </Container>
</Container>
  )
}
